<template>
  <v-row class="ml-0 mb-4">
    <v-card-title class="font-weight-bold">Histórico</v-card-title>
    <v-expansion-panels>
      <v-expansion-panel
        v-for="versao_anterior in historico"
        :key="versao_anterior.id_requisito"
      >
        <v-expansion-panel-title>
          <v-row no-gutters>
            <v-col class="d-flex align-center justify-space-between">
              <span>{{ versao_anterior.identificacao }}</span>
              <span class="mr-2">{{
                new Date(versao_anterior.dt_cadastro).toLocaleDateString(
                  'pt-br',
                )
              }}</span>
            </v-col>
          </v-row>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <div>
            <div class="mb-1 text-grey-darken-2">
              <span class="text-grey-darken-4 font-weight-bold">Tipo: </span
              >{{ formatarTipo(versao_anterior.tipo_requisito) }}
            </div>
            <div class="mb-1 text-grey-darken-2">
              <span class="text-grey-darken-4 font-weight-bold"
                >Descrição: </span
              >{{ versao_anterior.descricao }}
            </div>
            <div class="mb-1 text-grey-darken-2">
              <span class="text-grey-darken-4 font-weight-bold"
                >Observação: </span
              >{{ versao_anterior.observacao }}
            </div>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-row>
</template>

<script>
/**
 * @module HistoricoReq
 * @desc Paineis expansíveis que mostram o histórico de um determinado
 * requisito.
 * @vue-prop {Number} [reqID=0] Id do requisito
 * @vue-data {Array.<Object>} [historico=null] Uma lista contendo as versões
 * anteriores do requisito atual
 */
import axios from 'axios';

import store from '@/store/store';

const apiUrl = process.env.VUE_APP_API_URL;

export default {
  props: {
    reqID: {
      type: Number,
      default: 0,
      required: true,
    },
  },
  data() {
    return {
      historico: null,
    };
  },
  created() {
    this.getHistorico(this.reqID);
  },
  methods: {
    /**
     * Faz uma requisição HTTP para obter o histórico do requisito atual.
     *
     * @param {Number} id Id do requisito atual.
     */
    async getHistorico(id) {
      try {
        axios
          .get(`${apiUrl}/api/v1/requisitos/${id}/history`, {
            headers: {
              Authorization: `Bearer ${store.state.token}`,
            },
          })
          .then((res) => {
            this.historico = res.data.historyJson;
          });
      } catch (error) {
        console.log(error);
      }
    },
    formatarTipo(data) {
      const tipo = data.split('_')[1].toLowerCase();

      return tipo ? tipo[0].toUpperCase() + tipo.slice(1) : '';
    },
  },
};
</script>
